// features/toasts/ToastItem.tsx
import React from 'react';
import styles from './Toast.module.css';
import { Toast } from './toastSlice';

export const ToastItem: React.FC<{
  toast: Toast;
  onRemove: () => void;
}> = ({ toast, onRemove }) => {
  return (
    <div className={`${styles.toast} ${styles[toast.type]}`}>
      <div className={styles.title}>{toast.title}</div>
      <div className={styles.description}>{toast.description}</div>
      <button className={styles.close} onClick={onRemove}>
        ✖
      </button>
    </div>
  );
};
